<app-organization-sd
  [agency]="agencyService.agency"
>
</app-organization-sd>

<app-homepage-carousel
  [images]="images"
>
</app-homepage-carousel>

<h1
  class="page-title"
>
  {{ 'pages.home.stats.title' | translate }}
</h1>

<div
  fxLayout="row wrap"
  fxLayoutAlign="center center"
  class="statistics container"
>
  <div
    *ngFor="let i of ['0', '1', '2', '3', '4', '5']"
    fxLayout="column"
    fxLayoutAlign="center center"
    class="content"
  >
    <div
      fxLayout="row"
      fxLayoutAlign="center center"
      class="icon-wrapper gradient-background"
    >
      <img
        [src]="('pages.home.stats.' + i + '.icon_url' | translate)"
        alt="statistic icon"
        class="icon"
      >
    </div>
    <h3>
      {{ 'pages.home.stats.' + i + '.title' | translate }}
    </h3>
  </div>
</div>

<h1
  class="info container"
>
  {{ 'pages.home.info' | translate }}
</h1>

<section
  fxLayout="column"
  fxLayout.gt-sm="row"
  fxLayoutAlign="center center"
  fxLayoutAlign.gt-sm="center start"
  class="about-us-container"
>
  <div
    fxLayout="column"
    fxLayoutAlign="center center"
    class="about-us"
  >
    <h2
      class="title"
    >
      {{ 'pages.home.about.title' | translate }}
    </h2>
    <p style="white-space: pre-wrap;">{{ 'pages.home.about.content' | translate }}</p>
  </div>

  <div
    class="video about-us-image"
    [innerHtml]="videoInnerHTML"
    appGtagEvent
    eventCategory="video"
    eventAction="click"
    [eventLabel]="'video_render'"
    appFbqEvent="video"
    [customData]="{content_name: 'video_render', content_category: 'click'}"
  ></div>
</section>

<div
  *ngIf="bannerOpened"
  (click)="bannerOpened = false"
  class="banner"
>
  <div class="banner-content">
    <mat-icon>close</mat-icon>
    <img
      src="/assets/images/google iunie.jpg"
    >
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/home/home.component.html